import React from 'react';
import { BrowserRouter as Router, Route, Link, Switch } from 'react-router-dom'
import firebase from 'firebase';

import Loading from '../loading';

import GameFooter from './footer';
import Profiles from './profiles';
import Profile from './profile';
import Inactive from './inactive';

import {notify} from 'react-notify-toast';

class Game extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			game : null,
			profiles : null
		}
	}

	componentDidMount() {

		let self = this;

		// console.log('componentDidMount() Game',this.props.gameId);

		firebase.database().ref('games/' + this.props.gameId).on('value', (result) => {
			if(result.val()) {
				// console.log('game loaded', result.val());
				self.setState({ game: result.val() });
			}
			else { notify.show("Error Loading Game", "error")}

		});

		firebase.database().ref('profiles/' + this.props.gameId).on('value', (result) => {
			if(result.val()) {
				// console.log('profiles loaded', result.val());
				self.setState({ profiles: result.val() });
			}
			else { notify.show("Error Loading Game Profiles", "error")}
		});
	}

	render() {

		// If Deactivated, route to end screen
		if (!this.state.game || !this.state.profiles) {
			return <Loading text="Loading Game" />
		}

		// If Deactivated, route to end screen
		if (this.state.game && !this.state.game.active) {
			return <section>
			<Inactive game={this.state.game}/>
			<GameFooter user={this.props.user} userProfile={this.state.profiles[this.props.user.uid]} gameId={this.props.gameId} game={this.state.game}/>
			</section>
		}

		// If the user does not have a profile, create one

		return <section className="game">


		{/* <Switch> */}

		<Route exact path={`/game/${this.state.game.id}/:rankBy`} render={(routeProps)=>(
			<div>

				<header className="header">
					<h1>{this.state.game ? this.state.game.name : 'Loading'}</h1>
				</header>

				<main>
					<Profiles user={this.props.user} game={this.state.game} profiles={this.state.profiles} rankBy={routeProps.match.params.rankBy} />
				</main>

				<GameFooter user={this.props.user} userProfile={this.state.profiles[this.props.user.uid]} gameId={this.props.gameId} game={this.state.game}/>

			</div>
		)}/>
		<Route path={`/game/${this.state.game.id}/profile/:profileId/`} render={(routeProps)=>(
			<div>

				<header className="header">
					<h1>Your Profile</h1>
				</header>

				<main>
					<Profile user={this.props.user} game={this.state.game} profiles={this.state.profiles} profile={this.state.profiles[routeProps.match.params.profileId]} userProfile={this.state.profiles[this.props.user.uid]} />
				</main>

				<GameFooter user={this.props.user} userProfile={this.state.profiles[this.props.user.uid]} profile={this.state.profiles[routeProps.match.params.profileId]} gameId={this.props.gameId} game={this.state.game}/>

			</div>
		)}/>

		{/* </Switch> */}


		</section>
	}
}

export default Game



// WEBPACK FOOTER //
// ./src/components/game/index.js